import {styled} from "@mui/material/styles";
import { Typography } from '@mui/material';
import { useColors } from "../../Context/ColorsContext";
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, tablet, desktop } = MediaQuerys;

export const SectionFiles = styled('section')(({disabled}) => {
    const { colors } = useColors();
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '130px',
        alignItems: 'center',
        marginTop: 0,
        backgroundColor: disabled ? '#f9f9f9' : '#ffffff',
        border: '1px dashed #b7c6de',
        borderRadius: 8,
        color: disabled ? colors.disabled : colors.blackFont,
        cursor: disabled ? 'not-allowed' : 'pointer'
    }
})

export const Container = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    padding: '0'
}))

export const CustomSpan = styled(Typography)(() => {
    const { colors } = useColors();
    return {
        color: colors.grayFont,
        fontSize: 14,
        [desktop]: {
            fontSize: '0.90rem',
        }
    }
})


export const CustomTypography = styled(Typography)(() => {
    return {
        [desktop]: {
            fontSize: '0.90rem',
        }
    }
})

export const Text = styled(Typography)(() => {
    const { colors } = useColors();
    return {
        color: colors.grayFont,
        fontSize: 14,
        margin: 0,
        padding: 0,
        [desktop]: {
            fontSize: '0.95rem',
        },
        [tablet]: {
            fontSize: '0.85rem',
        }
    }
})

export const ContainerFiles = styled('ul')(() => {
    return {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        maxHeight: '150px',
        overflowY: 'auto'
    }
})

export const FileListContainer = styled('li')(() => {
    const { colors } = useColors();
    return {
        border: `1px solid #e4e7eb`, 
        borderRadius: '8px',
        padding: '6px 12px',
        marginBottom: '8px',
        backgroundColor: colors.white
    }
})

export const DropzoneIconContainer = styled('div')(() => {
    return {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: '#edf6ff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '10px'
    }
})

export const DropzoneTextMain = styled(Typography)(() => {
    const { colors } = useColors();
    return {
        color: colors.navbarColor,
        fontWeight: 'bold',
        fontSize: '12px',
        textAlign: 'center',
        marginBottom: '5px'
    }
})

export const DropzoneTextSub = styled(Typography)(() => {
    return {
        color: '#969fa8',
        fontSize: '11px',
        textAlign: 'center'
    }
})